import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class DatasetRepository {
  private static instance: DatasetRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): DatasetRepository {
    if (!DatasetRepository.instance) {
      DatasetRepository.instance = new DatasetRepository();
    }
    return DatasetRepository.instance;
  }

  public async getAllDatasets(): Promise<any> {
    return (await api.get(API_ROUTES.DATASETS))?.data;
  }

  public async createDataset(formData: FormData): Promise<any> {
    return (await api.post(API_ROUTES.DATASETS, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }))?.data;
  }

  public async updateDataset(id: string, payload: any): Promise<any> {
    return (await api.put(API_ROUTES.DATASETS_BY_ID(id), payload))?.data;
  }

  public async getDatasetById(id: string): Promise<any> {
    return (await api.get(API_ROUTES.DATASETS_BY_ID(id)))?.data;
  }

  public async deleteDataset(id: string): Promise<void> {
    return (await api.delete(API_ROUTES.DATASETS_BY_ID(id)))?.data;
  }

  /**
   * Get dataset template by type (single or multi-turn)
   */
  public async getDatasetTemplate(type: 'single' | 'multi-turn'): Promise<any> {
    return (await api.get(API_ROUTES.DATASET_TEMPLATE(type)))?.data;
  }
}
